export default __webpack_public_path__ + "static/media/2D.2371f69e.svg";